module.exports = __webpack_public_path__ + "static/stay-on-track-preview-d3d5556e817483fc4333a5d5a202b901.gif";